import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, Ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  ConclusionStep,
  ListDisplay,
  MessageFoundation,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { moneyFormat } from '@/modules/common/helpers/currency';
import { IWithdrawDetails } from '@/modules/transaction/services/variable-income';


export default /*#__PURE__*/_defineComponent({
  __name: 'Conclusion',
  setup(__props) {

const router = useRouter();

const portfolioId = inject('portfolioId') as Ref<string>;
const amountValue = inject('amountValue') as Ref<number>;

const withdrawDetails = inject('withdrawDetails') as Ref<IWithdrawDetails>;

const description = computed(() => {
  return `Resgate previsto para ${withdrawDetails.value.expectedRedemptionDate}`;
});

const conclusionDetails = computed(() => {
  return [
    {
      title: 'Origem',
      value: withdrawDetails.value.portfolioName
    },
    {
      title: 'Destino',
      value: 'Conta Warren'
    },
    {
      title: 'Valor bruto',
      value: moneyFormat(amountValue.value)
    }
  ];
});

const disclaimer = computed(() => {
  return 'O valor líquido do resgate é uma estimativa e pode variar conforme cotação, impostos e taxas no dia da liquidação.';
});

function goToPortfolio() {
  router.push({
    name: 'wealthIndexPortfolio',
    params: { portfolioId: portfolioId.value },
    query: {
      tab: 'orders'
    }
  });
}

return { __sfc: true,router, portfolioId, amountValue, withdrawDetails, description, conclusionDetails, disclaimer, goToPortfolio, ConclusionStep, ListDisplay, MessageFoundation, ButtonPrimary }
}

})